import { CheckIcon } from "./icons";

interface Props {
  steps: readonly string[];
  current: number;
}

// Presentational progress indicator. The spoken step change is handled by the
// aria-live region in App, so this is hidden from assistive tech.
export function StepIndicator({ steps, current }: Props) {
  return (
    <ol className="nv-steps" aria-hidden="true">
      {steps.map((label, i) => {
        const state = i < current ? "done" : i === current ? "current" : "upcoming";
        return (
          <li className={`nv-step-item ${state}`} key={label}>
            <span className="nv-step-dot">
              {state === "done" ? <CheckIcon size={14} /> : i + 1}
            </span>
            <span className="nv-step-name">{label}</span>
            {i < steps.length - 1 ? (
              <span className={`nv-step-rail${i < current ? " done" : ""}`} />
            ) : null}
          </li>
        );
      })}
    </ol>
  );
}
